import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Person } from '../../../models/person';
import { Usef_person } from '../../../models/usef/usef_person';

@Component({
  standalone: false,
  selector: 'app-modal-edit-person',
  templateUrl: './modal-edit-person.component.html',
styleUrls:  ['./modal-edit-person.component.css']
})
export class ModalEditPersonComponent implements OnInit {
	@Input() warning_language: string;
	@Input() person: Person;
  @Input() usef_person: Usef_person;
  @Output() person_saved$: EventEmitter<Person> = new EventEmitter<Person>();


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  handleSave(person: Person){
  	this.person_saved$.emit(person);
  }

}
